import { Button, BUTTON_VARIANTS } from 'ui/button';
import noop from 'utils/noop';

export type WorkflowLiveToggleProps = {
  isActive: boolean;
  onClick?: () => void;
  isDisabled?: boolean;
};

export const DISABLE_WORKFLOW_BUTTON_ID = 'disable-workflow';
export const ENABLE_WORKFLOW_BUTTON_ID = 'enable-workflow';

export const WorkflowLiveToggle = ({
  isActive,
  onClick = noop,
  isDisabled = false,
}: WorkflowLiveToggleProps) => {
  return isActive ? (
    <Button
      data-test={DISABLE_WORKFLOW_BUTTON_ID}
      onClick={onClick}
      variant={BUTTON_VARIANTS.DESTRUCTIVE}
      isDisabled={isDisabled}
    >
      Turn off
    </Button>
  ) : (
    <Button data-test={ENABLE_WORKFLOW_BUTTON_ID} onClick={onClick} isDisabled={isDisabled}>
      Turn on
    </Button>
  );
};
